"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WIX_MEDIA_STATIC = 'https://static.wixstatic.com/media/';
function getResizedImageUrl(imageURI, width, height, params) {
    return getResizedImagePartialUrl(WIX_MEDIA_STATIC, imageURI, width, height, params);
}
exports.getResizedImageUrl = getResizedImageUrl;
function getResizedImagePartialUrl(baseUrl, imageURI, width, height, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.usm_r, usm_r = _c === void 0 ? 0.66 : _c, _d = _b.usm_a, usm_a = _d === void 0 ? 1.00 : _d, _e = _b.usm_t, usm_t = _e === void 0 ? 0.01 : _e, quality = _b.quality;
    width = Math.round(width);
    height = Math.round(height);
    // Calculate default quality
    if (!quality) {
        var HIGH_QUALITY_RESOLUTION = 1400 * 1400;
        var MEDIUM_QUALITY_RESOLUTION = 600 * 600;
        var dimension = width * height;
        if (dimension > HIGH_QUALITY_RESOLUTION) {
            quality = 90;
        }
        else if (dimension > MEDIUM_QUALITY_RESOLUTION) {
            quality = 85;
        }
        else {
            quality = 80;
        }
    }
    return "" + baseUrl + imageURI + "/v1/fill/w_" + width + ",h_" + height + ",al_c,q_" + quality + ",usm_" + usm_r.toFixed(2) + "_" + usm_a.toFixed(2) + "_" + usm_t.toFixed(2) + "/" + imageURI;
}
exports.getResizedImagePartialUrl = getResizedImagePartialUrl;
exports.getImageUrl = function (relativeUrl) { return "" + WIX_MEDIA_STATIC + relativeUrl; };
